export default __webpack_public_path__ + "mini-icon-send-us-feedback@2x.png";